import { useContext } from 'react';
import S3DataAuthContext, { S3DataAuthContextValue } from './S3DataAuthContext';

const useS3DataAuth = (): S3DataAuthContextValue => {
	const context = useContext(S3DataAuthContext);
	return context;
};

export default useS3DataAuth;
